import './assets/css/vendor/bootstrap.min.css';
import './assets/css/vendor/bootstrap.rtl.only.min.css';
import 'react-circular-progressbar/dist/styles.css';
import 'react-perfect-scrollbar/dist/css/styles.css';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import 'react-table-6/react-table.css';
import './assets/css/CustomStyleSheet.css';
import './assets/css/index.css';
import '@/assets/css/sass/themes/gogo.light.blue.scss';

import { Buffer } from 'buffer';
window.Buffer = Buffer;

import('./AppRenderer');
